const messages: {[key: string]: string} = {
  "Lack of information": "There wasn't enough information about your organization. " +
    "Please make sure that you provide enough links (Discord, Twitter, your website, etc) " +
    "- and check that those links work - so we can understand more about it.",

  "Not Minecraft related": "We can only accept applications from organizations which are Minecraft-related.",
  "Not Minecraft related - no Minecraft videos/streams": "We can only accept applications from channels that " +
    "regularly upload Minecraft content - such as videos, streams, etc.",


  "Inappropriate": "We do not accept inappropriate content.",

  "Inactive": "We couldn't verify that your organization is active. Please make sure to provide links " +
    "(discord, IP, etc) so we can check this.",

  "Duplicate": "We have already received an application for this organization.",

  "Unaffiliated": "We can only accept applications from people who are affiliated with the organization, " +
    "and are allowed to apply on its behalf. Please show us that you have written permission to apply for a booth, " +
    "or ask someone who does to apply for you.",

  "Market saturation": "Unfortunately, we've received too many applications for this kind of organization. " +
    "We have a limited number of booth slots, and so we can't guarantee every organization will get accepted. " +
    "We'd love to see you apply again next year!",

  "Not an individual/project/org": "We can only accept booth applications for individuals, projects, or organizations.",
  "Non-family friendly content": "We can only accept booth applications for organizations or individuals which are, " +
    "for the most part, family friendly."
}

export default messages
